export class UserDto {
  username: string;
  agencyNumber: string;
  role: string;
  userid?: number;
  agentid?: number;
  agencyid?: number;
}
